'use strict';
import React, { Component } from 'react';
import Header from './Header.jsx';
import Body from './Body.jsx';
import Footer from './Footer.jsx';
import { createForm } from 'rc-form';

class Empresa extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let stateData = this.props.data;
        const { form } = this.props;

        return <form id="cuenta" name="cuenta" className="top-separator-xs left-separator-xs" method="POST">
            <div className="container-fluid">
                <Header data={stateData} />
                <Body data={stateData}
                    changeInput={this.props.changeInput}
                    changeCheck={this.props.changeCheck}
                    changeDate={this.props.changeDate}
                    changeDataError={this.props.changeDataError}
                    selectCombo={this.props.selectCombo}
                    filtroRubro={this.props.filtroRubro}
                    changeRubro={this.props.changeRubro}
                    cancelar={this.props.cancelar}
                    guardarNovedad={this.props.guardarNovedad}
                    guardarNovedades={this.props.guardarNovedades}
                    estadoEdicion={this.props.estadoEdicion}
                    guardarCampo={this.props.guardarCampo}
                    changeEditView={this.props.changeEditView}
                    changeText={this.props.changeText}
                    form={this.props.form}
                    mostrarModal={this.props.mostrarModal}
                    actualizarNovedadEstado={this.props.actualizarNovedadEstado}
                    actualizarNovedadEstados={this.props.actualizarNovedadEstados}
                />
                <br />
                <Footer data={stateData} />
            </div>
        </form>
    }
}

export default createForm()(Empresa);